import React from 'react';

/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.w
props.h
props.extraClass
*/

const UniEmptySpace = (props) => {
  let style = {};
  if (props.w > 0 || props.w === 0) {
    style.width = props.w;;
  }
  if (props.h > 0 || props.h === 0) {
    style.height = props.h;
  }
  let extraClass = '';
  if (typeof extraClass === 'string') {
    extraClass = ' ' + extraClass;
  }
  return (
    <div className={'unicompo-empty-space' + extraClass} style={style}></div>
  );
};

export default UniEmptySpace;